import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import ChildrenEntities from 'client/components/core/ChildrenEntities'
import { usePage, useWebsiteSettings } from 'client/store'
import { getFirstEntityByType } from 'client/store/page/pageSelectors'
import { EntityTypeEnum } from 'common/enums/entityTypeEnum'
import React from 'react'
import {
  getWebsiteStylesLayout,
  getWebsiteThemeBackground,
} from 'src/editor/store/website-settings/website-settings-selector'
import { CommonWebsitePageBody } from 'src/shared/entities/website-page-body'
import { CommonWebsitePageBodyNew } from 'src/shared/entities/website-page-body-new'
import { WebsitePageInterface } from 'src/shared/types/website-entities'

export interface WebsitePageBodyProps {
  entity: WebsitePageInterface
  isMoveUpAllowed: boolean
  isMoveDownAllowed: boolean
}

export const WebsitePageBody = ({ entity }: WebsitePageBodyProps) => {
  const layout = useWebsiteSettings(getWebsiteStylesLayout)
  const background = useWebsiteSettings(getWebsiteThemeBackground)
  const hasSection = !!usePage(page =>
    getFirstEntityByType(page, EntityTypeEnum.Section),
  )

  return (
    <BaseEntityNew
      entity={entity}
      isMoveUpAllowed={false}
      isMoveDownAllowed={false}
      isCopyAllowed={false}
      isRemoveAllowed={false}
      isSaveAllowed={false}
      styles={{ flex: 1 }}
    >
      {/* NOTE: Content without the Section can appear from a browser db saved content */}
      {hasSection ? (
        <CommonWebsitePageBodyNew htmlAttrId={entity.htmlAttrId}>
          <ChildrenEntities
            id={entity.id}
            childIds={entity.childIds}
            type={entity.type}
          />
        </CommonWebsitePageBodyNew>
      ) : (
        /* NOTE: Remove after migration is completed. */
        <CommonWebsitePageBody
          htmlAttrId={entity.htmlAttrId}
          contentWidth={layout?.contentWidth}
          background={
            background?.containerBackgroundColor ||
            background?.contentBackgroundColor
          }
        >
          <ChildrenEntities
            id={entity.id}
            childIds={entity.childIds}
            type={entity.type}
          />
        </CommonWebsitePageBody>
      )}
    </BaseEntityNew>
  )
}
